const booksData = [
  {
    title: "The Girl with The Dragon Tattoo",
    id: 1,
    discription:
      "Harriet Vanger, a scion of one of Sweden's wealthiest families disappeared over forty years ago. All these years later, her aged uncle continues to seek the truth. He hires Mikael Blomkvist, a crusading journalist recently trapped by a libel conviction, to investigate. He is aided by the pierced and tattooed punk prodigy Lisbeth Salander. Together they tap into a vein of unfathomable iniquity and astonishing corruption.",
    img: "https://images-na.ssl-images-amazon.com/images/I/81UhKOBDrCL.jpg",
  },
  {
    title: "The Girl who Played with Fire",
    id: 2,
    discription:
      "Mikael Blomkvist, crusading publisher of the magazine Millennium, has decided to run a story that will expose an extensive sex trafficking operation. On the eve of its publication, the two reporters responsible for the article are murdered, and the fingerprints found on the murder weapon belong to his friend, the troubled genius hacker Lisbeth Salander. Blomkvist, convinced of Salander’s innocence, plunges into an investigation. Meanwhile, Salander herself is drawn into a murderous game of cat and mouse, which forces her to face her dark past.",
    img: "https://images-na.ssl-images-amazon.com/images/I/A12eoRmZtsL.jpg",
  },
  {
    title: "The Girl who Kicked The Honrnets Nest",
    id: 3,
    discription:
      "In the third volume of the Millennium series, Lisbeth Salander lies in critical condition in a Swedish hospital, a bullet in her head. But she is fighting for her life in more ways than one: if and when she recovers, she will stand trial for three murders. With the help of Mikael Blomkvist, she will need to identify those in authority who have allowed the vulnerable, like herself, to suffer abuse and violence. And, on her own, she will seek revenge against the man who tried to killer her and against the corrupt government institutions that nearly destroyed her life.",
    img: "https://images-na.ssl-images-amazon.com/images/I/81kP8NZxm+L.jpg",
  },
];

export default booksData;
